import React from "react";
import styled from "styled-components";
import { Dispatcher } from "../../flux";
import Presentation from "./presentation";
import OverleafStore from "../../../../stores/overleaf-store";
import { OnBoardingHelper } from "../../components";
import { isFlashcardsEnabled } from "./utils";

const Error = styled.div.attrs({ className: "null-screen" })`
  margin: auto;
  margin-top: 200px;
`;

class FlashCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adding: !!props.newCardFront,
      currentDeck: props.deck || null,
      decks: null,
      error: null,
      findValue: "",
      newCardFront: props.newCardFront || null
    };

    this.add = this.add.bind(this);
    this.stopAdd = this.stopAdd.bind(this);
    this._closeFlashCardsPanel = this._closeFlashCardsPanel.bind(this);
    this.selectCurrentDeck = this.selectCurrentDeck.bind(this);
    this._getDecks = this._getDecks.bind(this);
    this.setFindValue = this.setFindValue.bind(this);
    this.onCreateRequest = this.onCreateRequest.bind(this);
  }

  componentDidMount() {
    OverleafStore.loadDecks({ isbn: this.props.isbn })
      .then(decks => {
        this.setState({ decks });
      })
      .catch(error => {
        this.setState({ error });
      });
    Dispatcher.on(Dispatcher.OVERLEAF_CHANGE, this._getDecks);
    Dispatcher.bind(Dispatcher.FLASHCARD_CREATE_REQUEST, this.onCreateRequest);
    Dispatcher.bind(Dispatcher.FLASHCARD_CLOSE_VIEWER, this.selectCurrentDeck);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.OVERLEAF_CHANGE, this._getDecks);
    Dispatcher.unbind(
      Dispatcher.FLASHCARD_CREATE_REQUEST,
      this.onCreateRequest
    );
    Dispatcher.unbind(
      Dispatcher.FLASHCARD_CLOSE_VIEWER,
      this.selectCurrentDeck
    );
    OverleafStore.reset();
  }

  onCreateRequest(props) {
    this.setState({
      currentDeck: props.deck,
      newCardFront: props.newCardFront,
      adding: true
    });
  }

  _getDecks() {
    OverleafStore.getDecks().then(decks => {
      this.setState(prevState => ({
        decks,
        currentDeck: prevState.currentDeck
          ? OverleafStore.get(prevState.currentDeck.uuid)
          : null
      }));
    });
  }

  add() {
    this.setState({ adding: true, show: true });
  }

  stopAdd() {
    OverleafStore.getDecks().then(decks => {
      this.setState(
        { adding: false, show: false, newCardFront: null, decks },
        () => {
          document.getElementById("flash-card-add").focus();
        }
      );
    });
  }

  _closeFlashCardsPanel() {
    Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "flashcards");
  }

  selectCurrentDeck(currentDeck) {
    this.setState({
      currentDeck,
      adding:
        currentDeck &&
        (currentDeck.card_count === 0 ||
          (currentDeck.cards && currentDeck.cards.length === 0))
    });
    if (currentDeck) {
      Fraction.Reporter.gaEvent(
        "V3/flashcards/panel",
        currentDeck.uuid,
        "select deck"
      );
    }
  }

  showOnboarding() {
    let levels = [
      {
        title: i18n.t("flashcards.onboarding.slide1.title"),
        image: "/img/flash-cards/assets/flash-ob-1.png",
        description: (
          <span>
            <div>
              {toHTML(i18n.t("flashcards.onboarding.slide1.description"))}
            </div>
          </span>
        )
      },
      {
        title: i18n.t("flashcards.onboarding.slide2.title"),
        image: "/img/flash-cards/assets/flash-ob-2.png",
        description: (
          <span>
            <div>
              {toHTML(i18n.t("flashcards.onboarding.slide2.description"))}
            </div>
          </span>
        )
      },
      {
        title: i18n.t("flashcards.onboarding.slide3.title"),
        image: "/img/flash-cards/assets/flash-ob-3.png",
        description: (
          <span>
            <div>
              {toHTML(i18n.t("flashcards.onboarding.slide3.description"))}
            </div>
          </span>
        )
      },
      {
        title: i18n.t("flashcards.onboarding.slide4.title"),
        image: "/img/flash-cards/assets/flash-ob-4.png",
        description: (
          <span>
            <div>
              {toHTML(i18n.t("flashcards.onboarding.slide4.description"))}
            </div>
          </span>
        )
      }
    ];
    OnBoardingHelper._newOnboarding(
      "chegg-ts-onboarding",
      levels,
      false,
      $(window),
      true
    );
  }

  setFindValue(findValue, callback) {
    this.setState({ findValue }, callback);
  }

  render() {
    const { adding, currentDeck, decks, findValue, newCardFront } = this.state;
    const { isbn, title } = this.props;

    if (this.state.error) {
      return (
        <Error>
          {Fraction.Brand.Graphics.watkins && (
            <img alt="" className="watkins" src="/img/prop_laptop_no.svg" />
          )}
          {i18n.t("reader.flashcards.response-error")}
        </Error>
      );
    }

    return (
      <Presentation
        add={this.add}
        adding={adding}
        cancel={this.stopAdd}
        close={this._closeFlashCardsPanel}
        currentDeck={currentDeck}
        decks={decks}
        findValue={findValue}
        isbn={isbn}
        selectCurrentDeck={this.selectCurrentDeck}
        showOnboarding={this.showOnboarding}
        newCardFront={newCardFront}
        setFindValue={this.setFindValue}
        title={title}
      />
    );
  }
}

const gadgetId = "flashcards";

module.exports = {
  class: FlashCards,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      description: i18n.t(`flashcards.lab-description`),
      notificationCount: false,
      expanded: false,
      hideHeader: true,
      type: "panel",
      lab:
        Fraction.Brand &&
        Fraction.Brand.Sidebar &&
        Fraction.Brand.Sidebar.Buttons.flashcards &&
        "graduate",
      starLab: false,
      toggle: false,
      enabled: isFlashcardsEnabled,
      sidebar: {
        icon: "/img/flashcards.svg",
        action: () => {
          if (!Fraction.Helpers.Labs.isLabEnabled(gadgetId)) {
            Fraction.Helpers.Labs.enableLab(gadgetId).then(() => {
              Dispatcher.emit(Dispatcher.PANEL_CHANGE);
            });
          }
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
